module.exports = __webpack_public_path__ + "static/img/90294e0478e2815e13a999cf47aeabdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_03.png
// module id = 9CeG
// module chunks = 1